import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-cccc096a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  class: "container"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Ver más tarde", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_5 = { class: "search-form" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_7 = { key: 0 }
const _hoisted_8 = {
  key: 1,
  class: "container-items"
}

import DefaultLayout from '@/layouts/DefaultLayout.vue'
import LessonService from '@/services/LessonService'
import { onMounted, ref, Ref } from 'vue'
import {useAuth} from '@/store/useAuth'
import LaterService from '@/services/LaterService'
import LessonList from '@/components/cards/LessonList.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'MyLatersView',
  setup(__props) {

const lessonService = new LessonService()
const loading = ref(true)
const store = useAuth()
const lessons:Ref<any> = ref([])
const filteredLessons:Ref<any> = ref([])
const lessonFollows = ref([])
const laterService = new LaterService()

const search: Ref<string> = ref('')


onMounted(async () => {
    loading.value = true
    if (store.token) {
        lessonFollows.value = await laterService.getAllFromUser(store.token)
    }
    lessonFollows.value.forEach(async (follow:any)=> {
        const item: any = await lessonService.getLesson(follow.lesson_id)
        lessons.value.push(item)
    });
    Promise.all(lessons.value)
    filteredLessons.value = lessons.value
    loading.value = false
})

const handleSearch = () => {
    loading.value = true
    filteredLessons.value = lessons.value.filter((item:any) => item.name.toLowerCase().includes(search.value.toLowerCase()))
    loading.value = false
}


return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createBlock(DefaultLayout, null, {
    default: _withCtx(() => [
      (loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_v_icon, {
              name: "ri-loader-2-fill",
              animation: "spin",
              class: "icon"
            })
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _hoisted_3,
            _hoisted_4,
            _createElementVNode("form", _hoisted_5, [
              _createVNode(_component_v_icon, { name: "fa-filter" }),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search).value = $event)),
                placeholder: "Escribe aquí para filtrar.",
                onKeyup: handleSearch
              }, null, 544), [
                [_vModelText, search.value]
              ])
            ]),
            _hoisted_6,
            (loading.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createVNode(_component_v_icon, {
                    name: "ri-loader-2-fill",
                    animation: "spin",
                    class: "icon"
                  })
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredLessons.value, (lesson) => {
                    return (_openBlock(), _createBlock(LessonList, {
                      key: lesson.id,
                      content: lesson
                    }, null, 8, ["content"]))
                  }), 128))
                ]))
          ]))
    ]),
    _: 1
  }))
}
}

})